<template>
  <form @submit.prevent="tryToSubmit">
    <b-field>
      <b-input
	v-model="value"
	:expanded="true"
	placeholder="Suchbegriff hier eingeben, e.g. Maier ..."
	type="search"
	icon="search"
      >
      </b-input>
      <p class="control">
	<b-button
	  v-if="hasTerm"
	  @click="reset"
	  icon-left="times"
	  tag="a"
	  type="button"
	>
	</b-button>
      </p>
      <p class="control">
	<b-button
	  @click="tryToSubmit"
	  :disabled="!canSubmit"
	  tag="button"
	  :loading="isLoading"
	  type="submit"
	  class="is-primary"
	>
	  {{$t('Search')}}
	</b-button>
      </p>
    </b-field>
  </form>
</template>

<script>
 import utilsMixin from '@/mixins/utils.js'

 import { debounce } from '@/utils/misc.js'

 import { createValidator } from '@/utils/validation.js'
 import { createMapper } from '@/utils/mapping.js'

 const validator = createValidator('tagsearch-form')
 const mapper = createMapper('tagsearch-form')

 export default {
   mixins: [utilsMixin],
   data() {
     return {
       isLoading: false,
       isFiltersOpen: false,
       value: '',
       type: ''
     }
   },
   watch: {
     '$route.query': {
       handler: 'syncFromQuery',
       immediate: true,
       deep: true
     }
   },
   computed: {
     canSubmit() {
       return !!this.value
     },
     hasChanges() {
       return !this.isDeepEqual(
	 this.cleanQuery(this.query),
	 this.cleanQuery(mapper.fromURL(this.$route.query))
       )
     },
     routeQuery() {
       return mapper.fromURL(this.$route.query)
     },
     hasTerm() {
       return !!this.routeQuery.value
     },
     query() {
       return {
   value: this.value,
   type: this.type
       }
     }
   },
   mounted() {
     this.tryToSubmit()
   },
   methods: {
     syncFromQuery(query) {
       let {
   value,
   type
       } = this.cleanQuery(mapper.fromURL(query))


       this.value = value
       this.type = type
     },
     syncWithQuery() {
       const query = mapper.toURL(this.query)
       this.$router.push({ query })
     },
     cleanQuery(query) {
       // FIXME: handle valid parameters
       return query
     },
     reset() {
       delete this.query.value;
       this.syncWithQuery()
     },
     tryToSubmit() {
       if (this.canSubmit) {
	 this.submit()
       }
     },
     submit: debounce(function () {
       this.syncWithQuery()
       this.isFiltersOpen = false
       this.$emit('submit', this.query)
     }, 50)
   }
 }
</script>
